import React, {Component} from 'react'
import PropsTypes from 'prop-types'
import {Alert, Modal} from "reactstrap"
import ChooseDevices from "./ChooseDevices";
import CreateNewAccount from "./CreateNewAccount";
import AccountRecord from './AccountRecord'
import AccountsPagination from "./AccountsPagination";
import UpdateAccountDataForm from "./UpdateAccountDataForm";

class AccountsPage extends Component {
    state = {
        device: ''
    }

    _handleChangeDevice = (device) => {
        this.setState({device})
    }

    render() {
        const {total, pagination, error, docs, isModalOpen} = this.props
        const {device} = this.state

        return (
            <div>
                {!!error ? <Alert color="danger">{error}</Alert> :
                    <div className='GoogleAccountsPage'>
                        <h2>Google Accounts ({total})</h2>
                        <div>
                            <div className='row'>
                                <CreateNewAccount onRefreshPage={this.props.onRefreshPage}/>
                                <ChooseDevices onChange={this._handleChangeDevice}/>
                            </div>
                            <div className='ListAccountsHeader row table-row'>
                                <div className='Order col'>#</div>
                                <div className='Email col'>Email</div>
                                <div className='Password col'>Password</div>
                                <div className='Phone col'>Phone</div>
                                <div className='RecoverEmail col'>Recover Email</div>
                                {/*<div className='RecoverPassword col'>Recover Password</div>*/}
                                <div className='Note col'>Note</div>
                                <div className='Proxy col'>Proxy</div>
                                <div className='Status col'>Status</div>
                                <div className='Actions col'>Actions</div>
                            </div>
                            {
                                docs.map((record, index) => {
                                    return <AccountRecord
                                        order={index + 1}
                                        device={device}
                                        key={record._id} record={record}
                                        onRefreshPage={this.props.onRefreshPage}
                                        removeAccountFormState={this.props.removeAccountFormState}
                                        onToggleModal={this.props.onToggleModal}
                                        onChangeModalData={this.props.onChangeModalData}
                                    />
                                })
                            }
                        </div>
                        <AccountsPagination paginationInfo={pagination} onChangePage={this.props.onChangePage}/>
                        <Modal isOpen={isModalOpen} toggle={this.props.onToggleModal} className={this.props.className}>
                            <UpdateAccountDataForm onToggleModal={this.props.onToggleModal}
                                                   modalData={this.props.modalData}
                                                   onChangeModalData={this.props.onChangeModalData}
                                                   onUpdateListAccounts={this.props.onUpdateListAccounts}
                                                   onCloseModal={this.props.onCloseModal}/>
                        </Modal>
                    </div>
                }
            </div>
        )
    }
}

AccountsPage.propsTypes = {
    onUpdateListAccounts: PropsTypes.func.isRequired,
    onCloseModal: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
    removeAccountFormState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    onChangePage: PropsTypes.func.isRequired,
    total: PropsTypes.number,
    pagination: PropsTypes.object.isRequired,
    error: PropsTypes.string,
    docs: PropsTypes.array.isRequired,
    isModalOpen: PropsTypes.bool.isRequired,
    modalData: PropsTypes.object.isRequired,
}

export default AccountsPage


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/AccountsPage.js